import { Component } from "react";
import PropTypes from "prop-types";
import GlobalBanner from "@asosteam/asos-web-global-banners";

class WithTargetedContent extends Component {
  constructor() {
    super();
    this.state = {
      contentRequested: false,
      subscriptionsSdkRequested: false,
      audienceSdkRequested: false
    };
  }

  componentDidMount() {
    this.manageRequest();
  }

  componentDidUpdate() {
    this.manageRequest();
  }

  manageRequest() {
    if (
      this.props.identityHasResponded &&
      !this.state.subscriptionsSdkRequested
    ) {
      this.props.getSubscriptionsFromSDK();
      this.setState({ subscriptionsSdkRequested: true });
    }

    if (
      this.props.identityHasResponded &&
      this.props.isLoggedIn &&
      !this.state.audienceSdkRequested
    ) {
      this.props.getAudiencesFromSDK();
      this.setState({ audienceSdkRequested: true });
    }

    if (
      this.props.identityHasResponded &&
      this.props.subscriptionsHasResponded &&
      (this.props.audienceHasResponded || !this.props.isLoggedIn) &&
      !this.state.contentRequested
    ) {
      const parameters = this.getParameters({ ...this.props });
      this.props.requestTargetedContent(parameters);
      this.setState({ contentRequested: true });
    }
  }

  getParameters(props) {
    const viewscope = this.getViewScope();
    const params = {
      country: props.country,
      store: props.store,
      lang: props.lang,
      keystoredataversion: props.keystoredataversion,
      isPremier: props.hasSubscriptions ? "true" : "false",
      segmentIds: props.audienceSegments,
      isKnown: props.isLoggedIn ? "true" : "false",
      ...(viewscope !== "default" && { viewscope: viewscope })
    };

    return params;
  }

  getViewScope() {
    return window.asos.webContext.getWebContext().floor;
  }

  render() {
    const emptyReturnValue =
      this.props.contentTargetingStatus === "SUCCESS" && !this.props.content;

    if (this.props.contentTargetingStatus === "ERROR" || emptyReturnValue) {
      return null;
    }

    return (
      <GlobalBanner
        content={this.props.content}
        status={this.props.contentTargetingStatus}
      />
    );
  }
}

WithTargetedContent.propTypes = {
  content: PropTypes.object,
  isLoggedIn: PropTypes.bool.isRequired,
  requestTargetedContent: PropTypes.func.isRequired,
  identityHasResponded: PropTypes.bool.isRequired,
  contentTargetingStatus: PropTypes.string.isRequired,
  getSubscriptionsFromSDK: PropTypes.func.isRequired,
  getAudiencesFromSDK: PropTypes.func.isRequired,
  hasSubscriptions: PropTypes.bool.isRequired,
  subscriptionsHasResponded: PropTypes.bool.isRequired,
  audienceHasResponded: PropTypes.bool.isRequired
};

export default WithTargetedContent;
